/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { ComponentLike, WithBoundArgs } from '@glint/template';

import type InfinityModel from 'ember-infinity/lib/infinity-model';
import type { Select } from 'ember-power-select/components/power-select';
import EmberPowerSelectOptions from 'ember-power-select/components/power-select/options';

type BvSelectOptionsArgs = Omit<EmberPowerSelectOptions['args'], 'options' | 'listboxId'> & {
  infiniteScroll?: boolean;
  infiniteModel?: InfinityModel;
  renderAll?: boolean;
  optionHeight?: number;
  bufferSize?: number;
  idForFirstItem?: string;
  optionKey?: string;
  isLoading?: boolean;
  options?: any[] | PromiseProxy<any[]> | InfinityModel;
};

export interface BvSelectOptionsSignature {
  Element: HTMLElement;
  Args: BvSelectOptionsArgs;
  Blocks: {
    default: [unknown, Select];
  };
}

type BvSelectionOptionsForRegistry = WithBoundArgs<
  ComponentLike<BvSelectOptionsSignature>,
  'select' | 'loadingMessage' | 'groupIndex'
>;

export default class BvSelectOptionsComponent extends EmberPowerSelectOptions {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvSelect::Options': BvSelectionOptionsForRegistry;
    'bv-select/options': BvSelectionOptionsForRegistry;
  }
}
